exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selector-btn {\n  width: 100%;\n  border-radius: 2px;\n  box-shadow: none;\n  padding: 3px 12px;\n  height: 24px;\n  font-size: 12px;\n  line-height: 1.8;\n  text-transform: none !important;\n  pointer-events: none; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/planning-poker-risk-indicator-header/planning-poker-risk-indicator-header.component.scss
// module id = ../../../../../src/app/components/planning-poker-risk-indicator-header/planning-poker-risk-indicator-header.component.scss
// module chunks = main